export default __webpack_public_path__ + "static/media/Diamond.e1ed50d7.png";